module.exports = __webpack_public_path__ + "static/media/video-modal.d5f4d080.jpg";